<template>
  <el-main class="el-mainContent">
    <p class="el-divider-header smallHeader">{{$t('base_setting')}}</p>
    <el-form label-position="top"  size="small" class="demo-form-inline">
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('ldapurl')" >
            <el-input type="text" v-model="detail.url" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('dirStructure')" >
            <el-input type="text" v-model="detail.dirStructure" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="baseDN：" >
            <el-input type="text" v-model="detail.baseDN" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('pooled')">
            <el-radio-group v-model="detail.pooled">
              <el-radio  label="true">{{$t('yes')}}</el-radio>
              <el-radio  label="false">{{$t('no')}}</el-radio>
            </el-radio-group>
          </el-form-item>
          
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('manager_account')" >
            <el-input type="text" v-model="detail.manager" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('managerPassword')" >
            <el-input type="text" v-model="detail.managerPassword" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <p class="el-divider-header smallHeader">{{$t('ldap_mapping')}}</p>
    <el-form label-position="top"  size="small" class="demo-form-inline"> 
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('userClass')" >
            <el-input type="text" v-model="detail.userClass" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('id_')" >
            <el-input type="text" v-model="detail.id_" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('name_')" >
            <el-input type="text" v-model="detail.name_" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('loginno_')" >
            <el-input type="text" v-model="detail.loginno_" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('loginpwd_')" >
            <el-input type="text" v-model="detail.loginpwd_" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('email_')" >
            <el-input type="text" v-model="detail.email_" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('telephone_')" >
            <el-input type="text" v-model="detail.telephone_" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-divider content-position="left" class="el-divider-header">{{$t('ldap_dept')}}</el-divider>
    <el-form label-position="top"  size="small" class="demo-form-inline">
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('deptClass')">
            <el-input type="text" v-model="detail.deptClass" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('enterDept')" >
            <el-input type="text" v-model="detail.enterDept" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-main>
</template>

<script>


export default {
  data(){
    return {
      customApps:[],
      custonAppsId:"",
    }
  },
  computed:{
  },
  props:["detail"],
  watch:{
    detail(newVal){
      this.detail=newVal;
      this.authType=this.detail.authType
      window.console.log(this.detail)
    },
    
  },
  created() {
   
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>

</style>